import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import { initialProjectDatasetState } from './constants';

export const projectDatasetSlice = createSlice({
  name: 'projectDatasetSlice',
  initialState: initialProjectDatasetState,
  reducers: {
    setProjectName: (state, action: PayloadAction<string | null>) => {
      state.projectName = action.payload;
    },
    setSiteName: (state, action: PayloadAction<string | null>) => {
      state.siteName = action.payload;
    },
    setIterationName: (state, action: PayloadAction<string | null>) => {
      state.iterationName = action.payload;
    },
  },
});

// Actions.
export const { setProjectName, setSiteName, setIterationName } =
  projectDatasetSlice.actions;

// Selector.
export const selectProjectDataset = (state: RootState) =>
  state.project.projectDataset;

//  Reducer.
export const projectDatasetReducer = projectDatasetSlice.reducer;
